<template>
  <v-container fluid class="px-2 px-sm-4 pb-12">
    <!-- Onboarding dialog -->
    <EmployeeGrowthOnboarding />

    <!-- Header -->
    <div class="d-flex align-center justify-space-between py-4">
      <div>
        <div class="d-flex align-center mb-1">
          <v-icon color="primary" class="mr-2">mdi-fire</v-icon>
          <span class="text-h6 font-weight-bold">Employee
            <span class="primary--text">Growth Tracker</span>
          </span>
        </div>
        <div class="caption grey--text">{{ todayLabel }} • Become Top 1% Today</div>
      </div>
      <div class="d-flex align-center" style="gap: 8px;">
        <v-btn small outlined color="primary" class="text-none" @click="$root.$emit('growth:start-tour')">
          <v-icon small class="mr-1">mdi-help-circle-outline</v-icon>
          <span class="d-none d-sm-inline">Tour</span>
        </v-btn>
        <v-btn small outlined color="error" class="text-none" @click="$root.$emit('growth:open-bug-dialog')">
          <v-icon small class="mr-1">mdi-bug-outline</v-icon>
          <span class="d-none d-sm-inline">Report a Bug</span>
        </v-btn>
        <v-btn small text @click="$root.$emit('growth:refresh'); $root.$emit('growth:leaderboard-refresh'); $toast.info('Refreshed!')">
          <v-icon small class="mr-1">mdi-refresh</v-icon>
          <span class="d-none d-sm-inline">Refresh</span>
        </v-btn>
        <v-btn small text>
          <v-icon small>mdi-bell-outline</v-icon>
        </v-btn>
      </div>
    </div>

    <v-row>
      <!-- Left main column -->
      <v-col cols="12" lg="9">
        <div data-tour="growth-role-profile"><RoleProfileCard /></div>
        <v-row>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-kpi"><KpiTrackerCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-areas"><GrowthAreasCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-focus"><TodaysFocusCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-ai"><AiCoachCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-habits"><HabitTrackerCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-feedback-send"><FeedbackSendCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-feedback-inbox"><FeedbackInboxCard class="flex-grow-1" /></v-col>
          <v-col cols="12" md="6" class="d-flex" data-tour="growth-anon-feedback"><AnonFeedbackCard class="flex-grow-1" /></v-col>
        </v-row>
      </v-col>

      <!-- Right sidebar -->
      <v-col cols="12" lg="3">
        <div data-tour="growth-score"><GrowthScoreCard /></div>
        <div data-tour="growth-leaderboard"><MonthlyLeaderboardCard /></div>
        <QuarterlyLeaderboardCard />
        <RecognitionCard />
        <BugTicketsCard />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RoleProfileCard          from './cards/RoleProfileCard.vue'
import KpiTrackerCard           from './cards/KpiTrackerCard.vue'
import GrowthAreasCard          from './cards/GrowthAreasCard.vue'
import TodaysFocusCard          from './cards/TodaysFocusCard.vue'
import AiCoachCard              from './cards/AiCoachCard.vue'
import HabitTrackerCard         from './cards/HabitTrackerCard.vue'
import FeedbackSendCard         from './cards/FeedbackSendCard.vue'
import FeedbackInboxCard        from './cards/FeedbackInboxCard.vue'
import AnonFeedbackCard         from './cards/AnonFeedbackCard.vue'
import GrowthScoreCard          from './cards/GrowthScoreCard.vue'
import MonthlyLeaderboardCard   from './cards/MonthlyLeaderboardCard.vue'
import QuarterlyLeaderboardCard from './cards/QuarterlyLeaderboardCard.vue'
import RecognitionCard          from './cards/RecognitionCard.vue'
import BugTicketsCard           from './cards/BugTicketsCard.vue'
import EmployeeGrowthOnboarding from './EmployeeGrowthOnboarding.vue'

export default {
  name: 'EmployeeGrowthComponent',
  components: {
    RoleProfileCard,
    KpiTrackerCard,
    GrowthAreasCard,
    TodaysFocusCard,
    AiCoachCard,
    HabitTrackerCard,
    FeedbackSendCard,
    FeedbackInboxCard,
    AnonFeedbackCard,
    GrowthScoreCard,
    MonthlyLeaderboardCard,
    QuarterlyLeaderboardCard,
    RecognitionCard,
    BugTicketsCard,
    EmployeeGrowthOnboarding,
  },
  data() {
    return {
      todayLabel: new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }),
    };
  },
};
</script>
